import React from 'react';
export function StickyNav() {
  return <div className="sticky top-0 z-50 w-full h-[56px] bg-navy-800 border-b border-white/10 flex items-center justify-between px-6" data-id="element-436">
      <div className="font-serif text-white text-sm font-medium" style={{
      fontVariant: 'small-caps'
    }} data-id="element-437">
        DiLore Publishing
      </div>
      <a href="#final-cta" className="bg-teal-400 hover:bg-gold text-navy-800 font-bold text-[13px] px-5 py-2 rounded-full transition-colors" data-id="element-438">
        Get Instant Access — $9.87
      </a>
    </div>;
}